import FormPage from './formPage';

export default FormPage;
